module.exports = __webpack_public_path__ + "Inter-Regular.woff2?18e83d6dfd14797c8ec0cb4ce904f233";


//////////////////
// WEBPACK FOOTER
// ./src/assets/font/Inter-woff2/Inter-Regular.woff2
// module id = 531
// module chunks = 309